import { render, staticRenderFns } from "./SimpleBox.vue?vue&type=template&id=53962e96"
import script from "./SimpleBox.vue?vue&type=script&lang=js"
export * from "./SimpleBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports